<template>
	<div class="item-container" @click="showDetails(data)">
		<p class="item-unread">{{data.title}}</p>
		<div class="item-content">{{ data.content }}</div>
		<div class="app-dashed-linear-gradient-horizontal-10 app-margin-top-20"></div>
		<p class="item-time app-text-right">{{ data.createTime }}</p>
		<el-dialog title="数网公告" :visible.sync="dialogVisible" width="30%" @close="closeDialog">
			<p class="app-font-size-18">{{ data.content }}</p>
			<div class="app-dashed-linear-gradient-horizontal-20"></div>
			<p class="app-text-right">{{ data.createTime }}</p>
		</el-dialog>
	</div>
</template>
<script>
import service from '../../../service/index';
export default {
	name: 'PersonalMessageAnnouncement',
	props: ['data'],
	inject: ['reload'],
	data() {
		return {
			detailsInfo: {
				createTime: '',
				content: ''
			},
			dialogVisible: false
		};
	},
	methods: {
		closeDialog() {
			this.dialogVisible = false;
			this.reload();
		},
		showDetails(id) {
			// this.$emit('showDetails', this.info, () => {
			// 	this.info.messageState = 0;
			// });
			let params = {
				id: this.data.id,
				isRead: '1'
			};
			service.getNews(params, res => {});
			this.dialogVisible = true;
		}
	}
};
</script>
<style scoped lang="scss">
.item-container {
	position: relative;
	background: #24262c;
	border-radius: 8px;
	padding: 0px 45px 30px;
	font-size: 24px;
	overflow: hidden;
	cursor: pointer;

	.item-circle-large {
		position: absolute;
		top: -32px;
		right: -32px;
		width: 100px;
		height: 100px;
		background: rgba(197, 31, 75, 0.27);
		border-radius: 50%;
		z-index: 11;
	}

	.item-circle-small {
		position: absolute;
		top: -22px;
		right: -22px;
		width: 80px;
		height: 80px;
		background: #c51f4b;
		border-radius: 50%;
		z-index: 21;
	}
	.item-circle-text {
		position: absolute;
		top: 8px;
		right: 8px;
		font-size: 18px;
		z-index: 31;
	}

	.item-unread {
		color: #c51f4b;
	}
	.item-time {
		font-size: 18px;
		color: #b9b9b9;
		line-height: 25px;
	}
	.item-content {
		margin-top: 13px;
	}
}
</style>
